import React, { Component } from "react";
import { Tab } from 'semantic-ui-react'
import CollectionsTabPane from './CollectionsTabPane';
import CraftingTabPane from './CraftingTabPane';
import QuestsTabPane from './QuestsTabPane';
import VendorTabPane from './VendorTabPane';

export default class ExtraInfoTabs extends Component {
    render() {
        const {quests, questRewards, ingredient, recipes, collections, vendors} = this.props;

        let panes = [];

        if(recipes && recipes.length > 0) {
            panes.push({
                menuItem: 'Created From',
                render: () => <Tab.Pane key='createdBy'><CraftingTabPane recipes={recipes} /></Tab.Pane>
            });
        }

        if(ingredient && ingredient.length > 0) {
            panes.push({
                menuItem: 'Ingredient In',
                render: () => <Tab.Pane key='ingredientIn'><CraftingTabPane recipes={ingredient} /></Tab.Pane>
            });
        }

        if(questRewards && questRewards.length > 0) {
            panes.push({
                menuItem: 'Rewarded From',
                render: () => <Tab.Pane key='questReward'><QuestsTabPane quests={questRewards} /></Tab.Pane>
            });
        }

        if(quests && quests.length > 0) {
            panes.push({
                menuItem: 'Used In Quest',
                render: () => <Tab.Pane key='questItem'><QuestsTabPane quests={quests} /></Tab.Pane>
            });
        }

        if(collections && collections.length > 0) {
            panes.push({
                menuItem: 'Artifact Collection',
                render: () => <Tab.Pane key='collections'><CollectionsTabPane collections={collections} /></Tab.Pane>
            });
        }

        if(vendors && vendors.length > 0) {
            panes.push({
                menuItem: 'Sold By',
                render: () => <Tab.Pane key='vendors'><VendorTabPane vendors={vendors}/></Tab.Pane>
            });
        }

        if(panes.length === 0) {
            return null;
        }

        return (
            <Tab panes={panes} menu={{ secondary: true, pointing: true }} style={{width: '100%'}}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/tabs/ExtraInfoTabs.jsx